"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = __importDefault(require("./common"));
const browser_1 = require("../plugins/reporting/browser");
const browser_2 = __importDefault(require("../plugins/transitionHooks/browser"));
class PluginManager extends common_1.default {
    constructor(...plugins) {
        super(['transitionHooks', 'reporting'], ...plugins);
    }
    getReportingPlugin() {
        const reporters = this.pluginsByType('reporting');
        return reporters.length > 0 ? (0, browser_1.reportingPluginsWrapper)(reporters.concat(browser_1.consoleReportingPlugin)) : browser_1.consoleReportingPlugin;
    }
    getTransitionHooksPlugin() {
        const [transitionHooksPlugin] = this.pluginsByType('transitionHooks');
        return transitionHooksPlugin || browser_2.default;
    }
    pluginsByType(type) {
        return super.pluginsByType(type);
    }
}
exports.default = PluginManager;
